import { Route } from '@angular/router'
import { authGuard, groupTypeGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type LookbookRoutes = {
    lookbookVendor: Route
}

export const lookbookRoutes: LookbookRoutes = {
    lookbookVendor: {
        path: 'dashboard/lookbook',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            groupTypeGuard({
                groupType: 'vendor',
                redirectTo: ['/dashboard/home/client'],
            }),
            permissionGuard([PERMISSIONS.shop.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('./page-lookbooks.component').then(
                (m) => m.PageLookbooksComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
}
